import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * U9 (2026-07-05): re-skinned to the house chip voice (`.chip` family,
 * components.css) — the previous Tailwind utility strings were inert
 * (tailwind.css was never imported; dependency removed in U8).
 *   default     → .chip-soft (primary-tinted)
 *   secondary   → .chip     (neutral)
 *   destructive → .chip--bad
 *   outline     → .chip
 */
const badgeVariants = cva("chip", {
  variants: {
    variant: {
      default: "chip-soft",
      secondary: "",
      destructive: "chip--bad",
      outline: "",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
